import { React, useCallback, useEffect, useMemo, useRef, useState } from 'react';
import Select from "react-select";
import DatePicker from "react-datepicker";
import 'react-datepicker/dist/react-datepicker.css';
import redirectURL from "../redirectURL";
import SweetAlert from "react-bootstrap-sweetalert";




const AddConsignmentSlider=({
    isOpen={isSliderOpen},
    onClose,
    courierPartnerList,vehicleFtlTypeList,consignees,invoiceNos,sourceSeriesList,seriesRecords,originalSourceList,sourceList,fuelTypeList, tptNFuel}) =>{
        const decipher = salt => {
            const textToChars = text => text.split('').map(c => c.charCodeAt(0));
            const applySaltToChar = code => textToChars(salt).reduce((a, b) => a ^ b, code);
            return encoded => encoded.match(/.{1,2}/g)
                .map(hex => parseInt(hex, 16))
                .map(applySaltToChar)
                .map(charCode => String.fromCharCode(charCode))
                .join('');
        }
        const decode = decipher("Z744cRBHYjQTsI6cOlNaUKbuEQF6MiEr")
        var localStorageEmail = localStorage.getItem("email")

    const [formData, setFormData] = useState({
           driver_mobile_no:'',
           source:{label:"", value:""},
           truck_no:'',
           truck_seal_no:'',
           other_source:"",
           other_source_pincode:"",
           other_transporter:"",
           other_vehicle_type:"",
           other_consignee_name:"",
           consigner_name:"",
           consignee_code:"",
           other_vehicle_capacity:"",
           other_destination_pincode:"",
           other_destination_city:"",
           entity:{label:"", value:""},
           vehicle_type:{label:'', value:''},
           courier_partner:{label:'', value:''},
           eway_bill_expiry_date:'',
           invoice_date:'',
           total_weight:'',
           total_cbm:'',
           vehicle_capacity:'',
           consignee_name:{label:"", value:""},
           consignee_name1:"",
           movement_type:{label:"", value:""},
           lr_no:'',
           invoice_no:[],
           invoice_no_str:"",
           number_of_boxes:'',
           destination_pincode:'',
           destination_city:'',
           show: false,
           basicType: '',
           basicTitle: '',
           sliderCreateConsignmentTranslate: '',
           loadshow: 'show-n',
           overly: 'show-n',
           disableAddDrop: true,
           disableSubmit: true, 
           dispatch_time:new Date(),
       });
    const [ enableCourierType, setEnableCourierType] = useState(false)
    const [error1, setError1] = useState('');
    const [ enableEdit, setEnableEdit ] = useState(true);
    const [ movementType, setMovementType ] = useState([
            { label:"Internal Movement", value:"Internal Movement" },
            { label:"Customer Delivery", value:"Customer Delivery" },
            { label:"Customer Returns", value:"Customer Returns" },
            { label: "Supplier Movement", value: "Supplier Movement" }
        ])
    const [sourceValidation, setSourceValidation] = useState(false);
    const [ enableSourceField,setEnableSourceField] = useState(false)
    const [ validOtherSource, setValidOtherSource] = useState(null)
    const [ sourceList1, setSourceList1] = useState([]);
    const [invoiceValid, setInvoiceValid] = useState(false);
    const [show, setShow] = useState(false)
    const [title, setTitle] = useState('')
    const [type, setType] = useState('default')
    const [isValid, setIsValid] = useState(true);
    const [errorMsg1, setErrorMsg1] = useState(false);
    const [ validateTruckNo, setValidTruckNo ] = useState(true);
    const [ entityList, setEntityList] = useState([
            {label:"Adlec", value:"Adlec"},
            {label:"Indoasian", value:"Indoasian"},
            {label:"Legrand", value: "Legrand"},
            {label:"Numeric", value:"Numeric"},
            {label:"Valrack", value:"Valrack"},
            {label:"Netrack", value:"Netrack"},
    ]);
    const [ enableVehicleType, setEnableVehicelType ] = useState(false)
    const [ enableConsignee, setEnableConsigee] = useState(false);
    const [validVehicleCapacity, setValidVehicleCapacity] = useState(null)
    const [loadshow, setLoadShow] = useState("show-n")
     const [manualTripUploadDetails, setManualTripUploadDetails] = useState([
            // {
            //   id: uuidv4(),
            //   lr_no: '',
            //   consignee_name: "",
            //   invoice_no: "",
            //   no_of_boxes: "",
            //   destination_pincode: "",
            //   destination_city: "",
            //   eway_bill_no: "",
            //   customer_mail_id: "",
            // }
        ]);
    const [isValid1,setIsValid1] = useState(false);
    const [overly, setOverlay] = useState("show-n");
    const [ dropPointConsignee,setDropPointConsignee ] = useState([]);
        const [ validOtherConsigneeName, setValidateOtherConsignee ] = useState(null);
        const [validCity, setValidCity] = useState(true);
    
    const [validCity1, setValidCity1] = useState(true);
    const [validPincode, setValidPincode] = useState(true);
    const [validPincode1, setValidPincode1] = useState(true);
    var [validFuelTypeList, setValidFuelTypeList]= useState(fuelTypeList)
    
    
    
    
    
    
useEffect(()=>{
    
    if(formData.consignee_name.value === "Other"){
        setEnableConsigee(true)
    }else{
        setEnableConsigee(false)
    }
},[formData.consignee_name.value])
    
const checkOtherConsigneeName = (fieldName, value) => {
    const pincodeRegex = /^[0-9]+$/;
    const cityRegex = /^[a-zA-Z\s]+$/;

    if (fieldName === "other_destination_city") {
        setValidCity(cityRegex.test(value));
    } else if (fieldName === "other_destination_pincode") {
        setValidPincode(pincodeRegex.test(value));
    } else if (fieldName === "other_consignee_pincode1") {
        setValidPincode1(pincodeRegex.test(value));
    } else if (fieldName === "other_consignee_city1") {
        setValidCity1(cityRegex.test(value));
    }

    if (formData.other_consignee_name !== "") {
        setIsOtherConsigneeName(false);
    }
};
    
    const enableOtherField = (e) => {
        if(e === "vehicleType"){
            if(formData.vehicle_type.value === "Others"){
                setEnableVehicelType(true)
            } else {
                setFormData(prev =>({...prev, other_vehicle_type:"",other_vehicle_capacity:""}))
                setEnableVehicelType(false)
            }
        }
        else if(e === "transporter"){
            if(formData.courier_partner.value === "Others"){
                setEnableCourierType(true)
            } else {
                setFormData(prev =>({...prev, other_transporter:""}))
                setEnableCourierType(false)
            }
        } 
        // else if(e === "vehicleCapacity"){
        //     if(formData.vehicle_capacity.value === "Others"){
        //         setEnableVehicleCapacity(true)
        //     } else {
        //         setFormData(prev =>({...prev, other_vehicle_capacity:""}))
        //         setEnableVehicleCapacity(false)
        //     }
        // } 
        else if(e === "consigneeName"){
            if(formData.consignee_name.value === "Others"){
                setEnableConsigee(true)
            } else {
                setFormData(prev =>({...prev, other_consignee_name:""}))
                setEnableConsigee(false)
                // let droppointconsigneelist = consignees.filter(e => e.value !== formData.consignee_name.value)
                // setDropPointConsignee(droppointconsigneelist)
            }
        }
      }
      const validateOption = (fieldType) => {
        switch(fieldType){        
            case "vehicleType":
                enableOtherField("vehicleType");
                break;
            case "transporter":
                enableOtherField("transporter");
                break;            
            case "vehicleCapacity":
                enableOtherField("vehicleCapacity");
                break;
            case "consigneeName":
                enableOtherField("consigneeName");
                break;
            case "dropConsigneeName":
                enableOtherField("dropConsigneeName");
                break;
            default:
                break;

        }
      }
      const handleDispatchDate = (date) => {
        if (!date) return; // Ensure a valid date is passed
        // Save the raw Date object for DatePicker
        
            setFormData((prev) => ({
                ...prev,
                dispatch_time: date,
            }));
            
    };
    const handleAddConsignmentInputChange = (e) => {
        const { name, value } = e.target;
    
        setFormData((prev) => ({
            ...prev,
            [name]: value, // Dynamically set the key-value pair based on the name attribute
        }));
    
        if (name === "other_source") {
            validateOtherSource(value); // Trigger validation for 'other_source' if applicable
        }
    };
    const validateOtherSource = (source) => {
        const regex = /^[a-zA-Z]+$/;  // Only letters allowed
        const isValid = regex.test(source);
        setValidOtherSource(isValid);
    };
    const validateInput=async(input) =>{
        if (input === "" || input === null || input === undefined) {
            setSourceList1(originalSourceList);
            return true;
        }
    
        const validateInvoice = (invoice) => {
            const regex = /^[A-Za-z0-9]+(\/[A-Za-z]+)?$/;
            return regex.test(invoice);
        };

        let params={
            invoice_nos: input
        }
    try {
        const resp = await redirectURL.post("/consignments/getinvoicenos", params);

        if (resp?.data?.total_invoices?.length > 0) {
            setShow(true);
             setTitle("Please select unique invoice no");
             setType("danger");
             return false;
         }
    } catch (err) {
        console.error("Error validating invoices:", err);
        
    }

        // Ensure all invoices are unique
        for (let i of input) {
            const lowerCase = i.toLowerCase();
           
            if (!validateInvoice(lowerCase)) {
                
                setShow(true);
                setTitle("All invoice's should be valid");
                setType("danger");
                return;
            }
            
        }
        
    
        let noSeries = true;
        for (let invoice of input) {
            if (invoice.includes("/")) {
                noSeries = false;
                break;
            }
        }
    
        if (noSeries) {
            setSourceList1(originalSourceList);
            setInvoiceValid(false);
            return true;
        }
    
        if (input.length >= 1) {
            let finalSource = new Set();
    
            // Function to validate invoice format
            
    
            for (let i = 0; i < input.length; i++) {
                const currentInvoice = input[i];
                
               
    
                if (currentInvoice.includes("/")) {
                    const currentSeries = currentInvoice.split("/")[1];
                    
                    var isSeriesValid=seriesRecords.includes(currentSeries.toUpperCase())
                    if(!isSeriesValid){
                        setShow(true);
                        setTitle("Please enter valid series");
                        setType("danger");
                        setInvoiceValid(false);
                        return;
                    }
                    const seriesList = sourceSeriesList.find(
                        (e) => e.value.toLowerCase() === currentSeries.toLowerCase()
                    );
    
                    if (seriesList) {
                        finalSource.add(seriesList.label);
                    }
                }
            }
    
    
            if (finalSource.size === 1) {
                const [value] = finalSource;
                let filteredSource = originalSourceList.filter((e) => e.value === value);
                filteredSource.push({ label: "Others", value: "Others" });
    
                setSourceList1(filteredSource);
                setFormData((prev) => ({
                    ...prev,
                    source: { label: filteredSource[0].label, value: filteredSource[0].value }
                }));
                setInvoiceValid(false);

                return true;
            }
        }
    }
    
    const handleInvoiceChange = (e) => {
        const value = e.target.value;

    
        const invoiceArray = value.split(',').map((item) => item.trim()).filter(Boolean);
        setFormData(prev => ({...prev, invoice_no_str: value, invoice_no: invoiceArray}));
        // if (invoiceArray.length > 0 && /[\/]/.test(invoiceArray[0])) {
        //     filterSources(invoiceArray);  // Call filterSources if the value contains a slash
        // } 
        // const isValid = validateInput(invoiceArray);
        // setIsValid(isValid);  
     };
    const handleTruckNoChange = (e) => {
        const {name, value} = e.target
        const value1 = value.toUpperCase().replace(/\s+/g, "");
        if(name=="truck_no"){
            setFormData(prev => ({...prev, truck_no: value1}));
        }

        validateTruckNoFun(value1);  
    };
    const validateTruckNoFun = (value) => {
        // Define the regex for the truck number format SN12TR2345
        const regex = /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{8,10}$/;        // Check if the input matches the regex pattern
        const isValid = regex.test(value);
        
        setValidTruckNo(isValid);
    };
    const fetchVehicleDetails = (x,y) => {
        let data = {
            vehicle_type: y,
        }
        redirectURL.post('/consignments/fetchVehicleDetails', data).then((resp) => {
            //console.log(resp, "889900");
            
        
            setFormData(prev => ({...prev, vehicle_capacity:resp.data.vehicleDetails[0].vehicle_capacity}))
        })
      }
    const handleInvoiceDate = (date) => {
        if (!date) return; // Ensure a valid date is passed
        // Save the raw Date object for DatePicker
        
            setFormData((prev) => ({
                ...prev,
                invoice_date: date,
            }));
            
    };
    const fetchConsignerDetails = (x,y) => {
        let data = {
            consigner_name: y,
            consigner_code: x
        }
        redirectURL.post('/consignments/fetchConsignerDetails', data).then((resp) => {
        
            setFormData(prev => ({...prev, destination_pincode:resp.data.consignerDetails[0].consigner_pincode,  destination_city:resp.data.consignerDetails[0].consigner_city}))
        })
      }
      const handleVehicleCapacityChange = (e) => {
        const value = e.target.value;
        setFormData(prev => ({...prev, other_vehicle_capacity: value}));
        validateVehicleCapacity(value);  // Validate in real-time on change
    };
    const validateVehicleCapacity = () => {
        const regex = /^[0-9]+$/;
        setValidVehicleCapacity(regex.test(formData.other_vehicle_capacity))

      }
    const handleEwayDate = (date) => {
        if (!date) return; // Ensure a valid date is passed
        // Save the raw Date object for DatePicker
        setFormData(prev => ({ ...prev, eway_bill_expiry_date: date }));
    };
    const isFormValid = () => {
        return (
          formData.invoice_no !== '' &&  formData.movement_type.value !== '' &&
          formData.driver_mobile_no !== '' && formData.source.value !== "" &&
          (formData.source.value === 'Others' ? !!formData.other_source : true) &&
          formData.truck_no !== '' &&
          formData.entity.value !== '' &&
          (formData.vehicle_type.value === 'Others' ? !!formData.other_vehicle_type : true) &&
          (formData.courier_partner.value === 'Others' ? !!formData.other_transporter : true) &&
          (formData.vehicle_capacity.value === 'Others' ? !!formData.vehicle_capacity : true) &&
          formData.consignee_name.value !== '' &&
          (formData.consignee_name.value === "Others" ? 
            (formData.other_consignee_name !== '' && 
             formData.other_destination_pincode !== '' && 
             formData.other_destination_city !== '') 
            : 
            (formData.destination_pincode !== '' && 
             formData.destination_city !== '')) &&
          formData.movement_type.value !== '' 
          
        );
    };
    const isManualTripUploadDetailsValid = () => {
        if (manualTripUploadDetails.length === 0) return true;
    
        // Get the most recent block
        const recentBlock = manualTripUploadDetails[manualTripUploadDetails.length - 1];
        const isOtherConsignee = recentBlock.consignee_name.length > 0 && recentBlock.consignee_name === 'Other';
        
        return (
            recentBlock.invoice_no !== '' &&  // Check if invoice_no is not empty
            recentBlock.consignee_name.length > 0 &&  // Check if there is at least one consignee name
            (!isOtherConsignee ||  // If the consignee is 'Other'
                (recentBlock.other_consignee_name !== '' &&  // Check if other_consignee_name is filled
                recentBlock.other_consignee_city !== '' &&  // Check if other_consignee_city is filled
                recentBlock.other_consignee_pincode !== ''))  // Check if other_consignee_pincode is filled
        );
    };
    const saveConsignmentData = async (event) => {
        event.preventDefault();
        setOverlay("show-m")
        
        let specialCharcters = 0;
        const { driver_mobile_no, source, truck_no, entity,truck_seal_no, vehicle_type, vehicle_capacity,courier_partner,eway_bill_expiry_date, consignee_name, movement_type, lr_no, invoice_no, number_of_boxes, destination_pincode, destination_city, other_source,other_source_pincode,total_cbm, total_weight, invoice_date,consignee_code, consigner_name,consignee_name1,dispatch_time,
            other_transporter,
            other_vehicle_type,
            other_consignee_name,
            other_vehicle_capacity,
            other_destination_pincode, other_destination_city,fuel_type } = formData;
        // let entityValues1 = selectedEntity.map(entity=> entity.value)
        let add_consignment_params = {}
        if (specialCharcters === 0) {
            let fieldsChk = 0;
            const isGeneralFieldsFilled = entity.value !== '' && dispatch_time && driver_mobile_no && !invoiceValid && source.value !== '' && truck_no !== '' &&
            vehicle_type.value !== '' && fuel_type.value !== '' && courier_partner.value !== '' && movement_type.value !== '' &&
            invoice_no.length >0  && invoice_date ;
        
        // console.log(dispatch_time, driver_mobile_no, !invoiceValid, source.value, truck_no, entity.value, vehicle_type.value,
        //     fuel_type.value, courier_partner.value, movement_type.value, invoice_no, invoice_date, total_weight, "allll fields8");
        
        // console.log(isGeneralFieldsFilled, "isGeneralFieldsFilled");
            
        
        // Check if consignee-related mandatory fields are filled based on the consignee selection
        const isConsigneeFilled = (consignee_name.value !== 'Others' && destination_city!=="" && destination_pincode!=="") 
            || (consignee_name.value === 'Others' && other_consignee_name!=="" && other_destination_city!=="" && other_destination_pincode!=="");
            // console.log(isConsigneeFilled, "isConsigneeFilled");

        const otherSource = (source.value ==="Others" && other_source!=="" && other_source_pincode!=="") ||( source.value !=="Others" && true);
        // console.log(otherSource, "otherSource");

        const vehicleTypeValidation = (vehicle_type.value ==="Others" && other_vehicle_capacity!=="" && other_vehicle_type!=="") || (vehicle_type.value !== "Others" && true)
        // console.log(vehicleTypeValidation, "vehicleTypeValidation");

        var consigneeValidation=true; 

        if(movement_type.value==="Customer Delivery"){
            if(!consignee_name1){
                consigneeValidation=false;
            }else{
                consigneeValidation=true;
            }
        }else{
            consigneeValidation=true;
        }
        // console.log("consigneeValidationm", consigneeValidation);
        
        if (isGeneralFieldsFilled && isConsigneeFilled && consigneeValidation && vehicleTypeValidation && otherSource) {
            // console.log("trueeeeee");
            
            fieldsChk = 1;
        }
        // console.log(fieldsChk, "fieldsChk");
        
            // if(other_source){
            //     fieldsChk = 1;
            // }
        var invoice_date1 = new Date(invoice_date);
        var dispatch_time1 = new Date(dispatch_time);

        if(fieldsChk === 1){
            if (dispatch_time1 > invoice_date1) {
                

                add_consignment_params = {
                    driver_mobile_no, 
                    source: source.label ? source.label: "",
                    truck_no,
                    truck_seal_no,
                    // entity: entityValues1.length>0 ? entityValues1 : [], 
                    entity: entity.value ? entity.value : "",
                    vehicle_type: vehicle_type.value, 
                    courier_partner: courier_partner.value.toUpperCase(), 
                    eway_bill_expiry_date: eway_bill_expiry_date ? formatDateForSubmission1(eway_bill_expiry_date) : "",        
                    invoice_date: invoice_date ? formatDateForSubmission(invoice_date):"",
                    dispatch_date: dispatch_time ? formatDateForSubmission1(dispatch_time):"",
                    total_weight: total_weight,
                    total_cbm: total_cbm,

                    vehicle_capacity: vehicle_capacity.value,
                    movement_type: movement_type.value, 
                    lr_no, 
                    // invoice_no: `${invoice_no}`, 
                    invoice_no:invoice_no,
                    no_of_boxes: number_of_boxes,
                    consigner_name:consigner_name,
                    fuel_type:fuel_type.value,
                    consignee_code: consignee_code
                };
                

                if(movement_type.value==="Customer Delivery"){
                    
                    add_consignment_params.consignee_name = formData.consignee_name1
                    add_consignment_params.destination_pincode = formData.destination_pincode;
                    add_consignment_params.destination_city = formData.destination_city;
                }
               
                if(consignee_name.value === "Others"){
                    add_consignment_params.consignee_name = formData.other_consignee_name
                    add_consignment_params.destination_pincode = formData.other_destination_pincode
                    add_consignment_params.destination_city = formData.other_destination_city
                }
                if(consignee_name.value !=="Others" && consignee_name1===""){
                    add_consignment_params.consignee_name = formData.consignee_name.label;
                    add_consignment_params.destination_pincode = formData.destination_pincode;
                    add_consignment_params.destination_city = formData.destination_city;
                }
                if(add_consignment_params.vehicle_type === "Others"){
                    add_consignment_params.vehicle_type = formData.other_vehicle_type
                }
                if(add_consignment_params.vehicle_capacity === "Others"){
                    add_consignment_params.vehicle_capacity = formData.other_vehicle_capacity
                }
                if(add_consignment_params.courier_partner === "Others"){
                    add_consignment_params.courier_partner = formData.other_transporter.toUpperCase()
                }
                if(other_source){
                    if(validOtherSource){
                        add_consignment_params.source = other_source;
                        add_consignment_params.source_pincode = other_source_pincode;
                    }
                }
                
                if (manualTripUploadDetails.length >= 1){
                    add_consignment_params.add_dealer=1
                }

                const manualDropPoints = manualTripUploadDetails.map((point) => ({
                    consignee_name: point.consignee_name === "Others" ? point.other_consignee_name : point.consignee_name,
                    customer_mail_id: point.customer_mail_id,
                    destination_city: point.consignee_name === "Others" ? point.other_consignee_city : point.destination_city,
                    destination_pincode: point.consignee_name === "Others" ? point.other_consignee_pincode : point.destination_pincode,
                    invoice_no: point.invoice_no,
                    lr_no: formData.lr_no,  // assuming lr_no is consistent across all points
                    no_of_boxes: point.no_of_boxes,
                    id: point.id
                }));
                const combinedParams = {
                    add_consignment_params,            // First set of params for updating the collection
                    manualTripUploadDetails :  manualDropPoints,
                    email:decode(localStorageEmail)  // Second set of params to be sent to the backend API
                };
                try { 
                    const response = await redirectURL.post('/consignments/saveConsignmentData', combinedParams);
                  
                //     // Check if the response is successful
                    if (response.data.status.toLowerCase() === 'success') {
                        
                      setShow(true);
                      setTitle(response.data.message);
                      setType('success');
                      setLoadShow('show-n');
                      setOverlay('show-n');
                      setInvoiceValid(false)
                        setValidTruckNo('')
                  
                //       // Clear form data
                      setFormData({
                        ...formData,
                        driver_mobile_no: '',
                        source: { label: "", value: "" },
                        truck_no: '',
                        truck_seal_no: '',
                        entity: '',
                        vehicle_type: { label: '', value: '' },
                        courier_partner: { label: '', value: '' },
                        eway_bill_expiry_date: '',
                        invoice_date:'',
                        total_weight:'',
                        total_cbm:'',
                        vehicle_capacity:'',
                        consignee_name: { label: "", value: "" },
                        movement_type: { label: "", value: "" },
                        lr_no: '',
                        invoice_no: [],
                        invoice_no_str:"",
                        consigner_name:"",
                        consignee_name1:"",
                        consignee_code:"",
                        number_of_boxes: '',
                        destination_pincode: '',
                        destination_city: '',
                        dispatch_time:new Date(),                        
                        fuel_type:{label:'', value:''}
                      });
                      setValidFuelTypeList(fuelTypeList)
                //       // Clear manual trip upload details
                      setManualTripUploadDetails([]);
                    //   setTimeout(() => {
                    //     setOverlay('show-n'); // This ensures only the slider closes
                    // }, 2000);
                //     //   window.location.reload();
                    } else if (response.data.status.toLowerCase() === 'failure') {
                //       // Show error message returned from backend
                      setShow(true);
                      setTitle(response.data.message); // Display the error message from the backend
                      setType("danger");
                    } else {
                      setShow(true);
                      setTitle(response.data.message === 'Consignment Code Already Exists' ? 
                        'Consignment Code Already Exists' : 'Failed to create consignment');
                      setType('danger');
                      setFormData({
                        ...formData,
                        driver_mobile_no: '',
                        source: '',
                        truck_no: '',
                        truck_seal_no: '',
                        entity: '',
                        vehicle_type: { label: '', value: '' },
                        courier_partner: { label: '', value: '' },
                        eway_bill_expiry_date: '',
                        invoice_date:'',
                        total_weight:'',
                        total_cbm:'',
                        vehicle_capacity: '',
                        consignee_name: '',
                        movement_type: '',
                        lr_no: '',
                        invoice_no: [],
                        invoice_no_str:"",
                        consigner_name:"",
                        consignee_name1:"",
                        consignee_code:"",
                        number_of_boxes: '',
                        destination_pincode: '',
                        destination_city: '',
                        dispatch_time:new Date(),
                        fuel_type:{label:'', value:''}
                      });
                      setManualTripUploadDetails([]);
                    
                    }
                  } catch (error) {
                //     // Handle any network or unexpected errors
                  
                    setShow(true);
                    setTitle("An unexpected error occurred. Please try again.");
                    setType("danger");
                  }
                  
            } else {
                setShow(true)
                setTitle("Dispatch Date should be greater than invoice date")
                setType("danger")
                setLoadShow('show-n')
                // setOverlay('show-n')
                              
            }
        }else{
            setShow(true)
            setTitle('Please fill mandatory fields')
            setType('danger') 
        }
    }   
         else {
            setShow(true)
            setTitle('Special characters are not allowed')
            setType('danger')
           
        }
    
    };
    const onClickHideAll = () => {
        setSourceValidation(false)
        // setManualInTransitStatusUpdate.dispatch_time("")
        // document.getElementById("File").value = "";
        setInvoiceValid(false)
        setValidTruckNo(true);
        
        setOverlay("show-n")
        setLoadShow("show-n")
        setManualTripUploadDetails([])
        setFormData({
            driver_mobile_no:'',
            source:'',
            other_source:'',
            other_source_pincode:'',
            truck_no:'',
            truck_seal_no:'',
            entity:'',
            vehicle_type:{label:'', value:''},
            courier_partner:{label:'', value:''},
            eway_bill_expiry_date:'',
            invoice_date:'',
            total_weight:'',
            total_cbm:'',
            vehicle_capacity:'',
            consignee_name:'',
            movement_type:'',
            lr_no:'',
            invoice_no:[],
            invoice_no_str:"",
            consigner_name:"",
            consignee_name1:"",
            number_of_boxes:'',
            destination_pincode:'',
            destination_city:'',
            show: false,
            basicType: '',
            basicTitle: '',
            sliderCreateConsignmentTranslate: '',
            loadshow: 'show-n',
            overly: 'show-n',
            dispatch_time:new Date(),
            fuel_type:{label:'', value:''},
            consignee_code:""

        })
        setValidFuelTypeList(fuelTypeList)

        setSourceList1(originalSourceList)
        if (typeof onClose === "function") {
            onClose();  // Call the function to close the slider
        } else {
            console.error("onClose is not a function");
        }    }
        const onConfirm = () => {
            setShow(false);

            // setLoader(false)
            // if (reloadPage.current) {
            //   
            //   window.location.reload()
            // }
            
                if (type === 'success'){
                    onClose();
                    window.location.reload()
                }
            
           
    
        };
        const fetchingMaxFuelType=async(tptName)=>{
            
             await redirectURL.post("/consignments/getMaxFuelType").then((response)=>{
                        if(response.data.status ==="success"){
                            let tptNfuelData = response.data.result;
                
                            let validMaxFuelType = tptNfuelData[tptName.toUpperCase()]
                            
                                        
                            setFormData((prev)=>({
                                ...prev,
                                fuel_type: {label: validMaxFuelType, value:validMaxFuelType}
                            }))
                        }
                    })
        }
   
    return (
        <>
        <SweetAlert
                        show={show}
                        title={<span style={{ fontSize: "1rem" }}>{title}</span>}
                        onConfirm={onConfirm}
                        confirmBtnBsStyle={type}
                        confirmBtnCssClass="sweetButton"
                        customClass='sweetWidth'
                        type={type}>
                    </SweetAlert>
        <div className={`slide-r ${isOpen ? "slider-translate-30p" : ""}`} style={{ overflowX: "hidden", overflowY: "auto", maxHeight: "100vh" }}>
            <div className="slide-r-title">
                <h4 className="slide-r-title">
                    Add Consignment
                    <span className="float-right closebtn" style={{ marginRight: "10px" }} onClick={onClickHideAll}>
                        X
                    </span>
                </h4>
            </div>

            <div className="row" style={{ padding: "20px" }}>
                <div className="col-sm-12"></div>
                <form method="POST" className="theme-form col-xl-12 col-lg-12" onSubmit={saveConsignmentData}>
                    <div className="slide-body">
                        <div className="row">
                            {/* LR No */}
                            <div className="col-xl-12 col-lg-12 form-group">
                                <label className="mb-5p">LR No <span style={{ color: 'red' }}>*</span></label>
                                <input
                                                type="text"
                                                className="form-control"
                                                onChange={(e) => {
                                                    // Only update state if the input is a valid number
                                                    const value = e.target.value;
                                                    // if ((/^[a-zA-Z0-9]*$/.test(value))) {  // This regex allows only numeric values /* PMS ID - 10259 */
                                                    if (/^[^\s]*$/.test(value)) {
                                                        setFormData(prev => ({ ...prev, lr_no: value }));
                                                    }
                                                    // }
                                                }}
                                               
                                                value={formData.lr_no}
                                                name="lr_no"
                                                autoComplete="off"
                                                required
                                                // placeholder="Enter LR No"
                                            />
                            </div>

                            {/* Transporter */}
                            <div className="form-group col-xl-12 col-lg-12">
                                            <label className="mb-5p">
                                                Transporter<span style={{color: 'red'}}>*</span>
                                            </label>
                                            <Select
                                                closeMenuOnSelect={true}
                                                value={formData.courier_partner}
                                                onChange={(e) => {
                                                    setFormData((prev) => ({
                                                        ...prev,
                                                        courier_partner: { label: e.label, value: e.value }
                                                    }));
                                                    var tptName1 = e.label.toLowerCase();
                                                    fetchingMaxFuelType(tptName1)
                                                    var validFuelType=tptNFuel.filter(tpt=> (tpt.label.toLowerCase()===tptName1)).map(e=>e.value).flat()
                                                    var validFuelTypes = validFuelType.map(e=> ({label:e, value:e}))
                                                    setValidFuelTypeList(validFuelTypes)

                                                    // Enable Other Transporter field when "Other" is selected
                                                    if (e.value === "Others") {
                                                        setEnableCourierType(true);
                                                    } else {
                                                        setFormData((prev) => ({ ...prev, other_transporter: "" }));
                                                        setEnableCourierType(false);
                                                    }
                                                }}
                                                style={{ borderRadius: "0px" }}
                                                styles={{
                                                    control: (provided, state) => ({
                                                        ...provided,
                                                        fontSize: "0.8rem",
                                                        color: "#6e707e",
                                                        width:"100%"

                                                    }),
                                                    singleValue: (provided, state) => ({
                                                        ...provided,
                                                        fontSize: "0.9rem",
                                                    }),
                                                }}
                                                options={courierPartnerList}
                                            />
                                        </div>

                            {/* Other Transporter */}
                            {enableCourierType && <div className="col-xl-12 col-lg-12 form-group">
                                            <label className="mb-5p">Other Transporter<span style={{color:'red'}}>*</span>  </label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                onChange={(e)=> setFormData(prev =>({...prev, other_transporter:e.target.value}))}
                                                value={formData.other_transporter}
                                                name="truck_no"
                                                autoComplete='off'
                                                required
                                            />
                                        </div>}
                                 {/* driver mobile no */}
                                 <div className="col-xl-12 col-lg-12 form-group">
                                            <label className="mb-5p">Driver Mobile No.<span style={{color:'red'}}>*</span> </label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                onChange={(e) => {
                                                    const { name } = e.target;
                                                    const numericValue = e.target.value.replace(/\D/g, '').slice(0, 10);
                                                    
                                                    // Validate the input length and content
                                                    if (numericValue.length < 10) {
                                                        setError1('Mobile number must be 10 digits long');
                                                    } else if (!/^[6-9]\d{9}$/.test(numericValue)) {
                                                        setError1('Mobile number must start with a digit between 6 and 9 and be 10 digits long');
                                                    } else {
                                                        setError1(''); // Clear error if the number is valid
                                                    }

                                                    // Update the state with the new value (allow only 10 digits max)
                                                    if (numericValue.length <= 10) {
                                                      if (name === 'driver_mobile_no') {
                                                            setFormData((prev) => ({ ...prev, driver_mobile_no: numericValue }));
                                                        }
                                                    }
                                                }}
                                                value={formData.driver_mobile_no}
                                                name="driver_mobile_no"
                                                autoComplete='off'
                                                required
                                            />
                                            {error1 && <span style={{ color: 'red', fontSize: "10px", margin: "10px 0px 0px 0px" }}>{error1}</span>}                    
                                        </div>
                            {/* Dispatch Date */}
                            <div className="form-group col-xl-12 col-lg-12">
                                            <label className="mb-5p">
                                            Dispatch Date<span style={{color:'red'}}>*</span>
                                            </label>
                                        <div id="datepicker1">
                                                <DatePicker
                                            selected={formData.dispatch_time}
                                            onChange={(date) => handleDispatchDate(date)} 
                                            name="dispatch_time"
                                            className="datepicker-custom-ptl4 form-control"
                                            showTimeSelect
                                            maxDate={new Date()}
                                            timeFormat="HH:mm"
                                            timeIntervals={15} // Adjust this if you want different time intervals
                                            timeCaption="Time"
                                            dateFormat="dd-MM-yyyy HH:mm" // Adjusted format to match the original format
                                            // placeholderText="Date" // Equivalent to placeholder in the original
                                            id="dispatch_time"
                                            autoComplete='off'
                                            onKeyDown={(e) => e.preventDefault()}
                                            // style={{width:"100%"}}
                                            />
                                        </div>
                                        
                                        </div>

                            {/* Movement Type */}
                            <div className="col-xl-12 col-lg-12 form-group">
                                            <label className="mb-5p">Movement Type<span style={{color:'red'}}>*</span>  </label>
                                            <Select
                                                closeMenuOnSelect={true}
                                                value={formData.movement_type}
                                                onChange={(e) => {
                                                    // Update formData and enableEdit state together
                                                    setFormData((prev) => ({
                                                        ...prev,
                                                        movement_type: { label: e.label, value: e.value },
                                                    }));
                                                    setFormData((prev) => ({
                                                        ...prev, 
                                                        consignee_name: {label: "", value: ""}
                                                    }));
                                            
                                                    // Update enableEdit state based on the selected value
                                                    if (e.value === "Customer Delivery") {
                                                        setEnableEdit(true);
                                                    } else {
                                                        setEnableEdit(false);
                                                    }
                                                }}
                                                style={{ borderRadius: "0px" }}
                                                styles={{
                                                    control: (provided, state) => ({
                                                    ...provided,
                                                    fontSize: "0.8rem",
                                                    color: "#6e707e",
                                                    width:"100%"

                                                    }),
                                                    singleValue: (provided, state) => ({
                                                    ...provided,
                                                    fontSize: "0.9rem",
                                                    }),
                                                }}
                                                options={movementType}
                                            />                                        
                                        </div>

                            {/* Source */}
                            <div className="form-group col-xl-12 col-lg-12">
                                            <label className="mb-5p">Source<span style={{color:'red'}}>*</span></label>
                                            <Select
                                                closeMenuOnSelect={true}
                                                value={formData.source}
                                                isDisabled={sourceValidation}
                                                onChange={(e) => {
                                                        setFormData((prev) => ({
                                                            ...prev,
                                                            source: { label: e.label, value: e.value }
                                                        }));
                                                        if (e.value === "Others") {
                                                            setEnableSourceField(true);
                                                        } else {
                                                            setFormData((prev) => ({ ...prev, other_source: "" }));
                                                            setEnableSourceField(false);
                                                        }
                                                    // else {
                                                    //     setErrorMssge("Please fill in the invoice_no field first");
                                                    // }
                                                }}
                                                style={{ borderRadius: "0px" }}
                                                styles={{
                                                    control: (provided, state) => ({
                                                        ...provided,
                                                        fontSize: "0.8rem",
                                                        color: "#6e707e",
                                                        width:"100%"
                                                    }),
                                                    singleValue: (provided, state) => ({
                                                        ...provided,
                                                        fontSize: "0.9rem",
                                                    }),
                                                }}
                                                options={sourceList}
                                            />
                                             {sourceValidation && <span style={{color:"red", fontSize:"12px", marginTop:"5px"}}>
                                             Please enter valid Invoice Numbers. The source will be auto-filled accordingly.                                            </span>}
                                        </div>
                                        {enableSourceField && <div className="col-xl-12 col-lg-12 form-group">
                                            <label className="mb-5p">
                                                Other Source<span style={{color:'red'}}>*</span>
                                            </label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                onChange={handleAddConsignmentInputChange}
                                                value={formData.other_source}
                                                name="other_source"
                                                autoComplete="off"
                                                required
                                            />
                                            {validOtherSource === false && (
                                                <span style={{color:"red", fontSize:"12px", marginTop:"5px", marginLeft:"16px"}}>
                                                    Enter Valid Source Name
                                                </span>
                                            )}
                                        </div>}
                                        {enableSourceField && (
                                        <div className="col-xl-12 col-lg-12 form-group">
                                            <label className="mb-5p">
                                                Others Source Pincode<span style={{ color: 'red' }}>*</span>
                                            </label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                onChange={handleAddConsignmentInputChange}
                                                value={formData.other_source_pincode}
                                                name="other_source_pincode"
                                                autoComplete="off"
                                                required
                                            />
                                            {/* Optionally display error message */}
                                            {/* {!/^[0-9]{6}$/.test(formData.other_source_pincode) && formData.other_source_pincode !== '' && (
                                                <span style={{ color: "red", fontSize: "12px", marginTop: "5px", marginLeft: "16px" }}>
                                                    Pincode must be 6 digits.
                                                </span>
                                            )} */}
                                        </div>
                                    )}

                                     {/* invoice no */}
                                     <div className="col-xl-12 col-lg-12 form-group">
                                            <label className="mb-5p">
                                                Invoice No<span style={{color:'red'}}>*</span>
                                            </label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                onChange={(e) => handleInvoiceChange(e)}
                                                onBlur={async() => {
                                                    const isValid = await validateInput(formData.invoice_no);
                                                    
                                                    
                                                    setIsValid(isValid);
                                                    if (!isValid) {
                                                        setSourceValidation(true)
                                                        setErrorMsg1(true)
                                                        setInvoiceValid(true)
                                                        console.error("Validation failed for invoice input.");
                                                    }else{
                                                        setSourceValidation(false)
                                                        setInvoiceValid(false)
                                                    }
                                                }}
                                                value={formData.invoice_no_str}
                                                name="invoice_no"
                                                autoComplete="off"
                                                required
                                            />
                                            {invoiceValid && <span style={{color:"red", fontSize:"12px", marginTop:"5px"}}>
                                                Enter the Valid Invoice No's
                                            </span>}
                                        </div>

                                     {/* invoice date */}
                                     <div className="form-group col-xl-12 col-lg-12">
                                            <label className="mb-5p">Invoice Date<span style={{color: 'red'}}>*</span></label>
                                            <div id="datepicker1">
                                                <DatePicker
                                                selected={formData.invoice_date}
                                                onChange={(date)=>handleInvoiceDate(date)}
                                                name="invoice_date"
                                                className="datepicker-custom-ptl4 form-control1"
                                                showTimeSelect={false}
                                                // timeFormat="HH:mm:ss"
                                                // timeIntervals={15} // Adjust this if you want different time intervals
                                                // timeCaption="Time"
                                                dateFormat="dd-MM-yyyy" // Adjusted format to match the original format
                                                maxDate={new Date()}
                                                id="invoice_date"
                                                autoComplete="off"
                                                onKeyDown={(e) => e.preventDefault()}
                                                />
                                            </div>
                                        </div>

                                    {/* consignor name */}
                                        <div className="col-xl-12 col-lg-12 form-group">
                                                    <label className="mb-5p">Consignor Name</label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        onChange={(e) => {
                                                            const { value } = e.target;
                                                            setFormData(prev => ({...prev, consigner_name: value}));
                                                            // validateOtherConsignee(value);
                                                        }}
                                                        value={formData.consigner_name}
                                                        name="consigner_name"
                                                        autoComplete='off'
                                                    />
                                                    {/* {validOtherConsigneeName === false && <span style={{color:"red", fontSize:"12px", marginTop:"5px"}}>Enter Valid Consignee Name</span>} */}
                                                </div>
                                     {/* truck no */}
                                     <div className="col-xl-12 col-lg-12 form-group">
                                            <label className="mb-5p">
                                                Truck No<span style={{color:'red'}}>*</span>
                                            </label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                onChange={handleTruckNoChange}  
                                                value={formData.truck_no}
                                                name="truck_no"
                                                autoComplete='off'
                                                required
                                            />
                                            {validateTruckNo === false && (
                                                <span style={{color:"red", fontSize:"12px", marginTop:"5px", marginLeft:"0px"}}>
                                                    Enter Valid Truck Number
                                                </span>
                                            )}
                                        </div>
                                     {/* truck seal no */}
                                     <div className="col-xl-12 col-lg-12 form-group">
                                            <label className="mb-5p">Truck Seal No </label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                onChange={(e)=> setFormData(prev =>({...prev, truck_seal_no:e.target.value}))}
                                                value={formData.truck_seal_no}
                                                name="truck_seal_no"
                                                autoComplete='off'
                                            />
                                        </div>

                                     {/* entity */}
                                     <div className="col-xl-12 col-lg-12 form-group">
                                            <label className="mb-5p">Entity<span style={{color: 'red'}}>*</span></label>
                                            <Select
                                                // closeMenuOnSelect={false}
                                                // isMulti={true}
                                                // value={selectedEntity}
                                                closeMenuOnSelect={true}
                                                value={formData.entity}
                                                onChange={(e)=> setFormData((prev)=>({
                                                    ...prev, 
                                                    entity:{label:e.label, value: e.value}
                                                }))}
                                                // onChange ={e=> setSelectedEntity(e)}
                                                style={{ borderRadius: "0px" }}
                                                styles={{
                                                    control: (provided, state) => ({
                                                    ...provided,
                                                    fontSize: "0.8rem",
                                                    color: "#6e707e",
                                                    width:"100%"
                                                    }),
                                                    singleValue: (provided, state) => ({
                                                    ...provided,
                                                    fontSize: "0.9rem",
                                                    }),
                                                }}
                                                options={entityList}
                                            />
                                        </div>
                                           {/* vehicle type */}
                                           <div className="form-group col-xl-12 col-lg-12">
                                            <label className="mb-5p">
                                                Vehicle Type<span style={{color: 'red'}}>*</span>
                                            </label>
                                            <Select
                                                closeMenuOnSelect={true}
                                                value={formData.vehicle_type}
                                                onChange={(e) => {
                                                    setFormData((prev) => ({
                                                        ...prev,
                                                        vehicle_type: { label: e.label, value: e.value }
                                                    }));
                                                    if (e.value === "Others") {
                                                        setEnableVehicelType(true);
                                                        setFormData((prev) => ({ ...prev, other_vehicle_type: "" , other_vehicle_capacity:''}));

                                                    } else {
                                                        setEnableVehicelType(false);
                                                        fetchVehicleDetails(e.label, e.value)
                                                        
                                                    }
                                                }}
                                                style={{ borderRadius: "0px", maxWidth: "415px" }}
                                                styles={{
                                                    control: (provided, state) => ({
                                                        ...provided,
                                                        fontSize: "0.8rem",
                                                        color: "#6e707e",
                                                        width:"100%"

                                                    }),
                                                    singleValue: (provided, state) => ({
                                                        ...provided,
                                                        fontSize: "0.9rem",
                                                    }),
                                                }}
                                                options={vehicleFtlTypeList}                                            />
                                        </div>
                                        {enableVehicleType && <div className="col-xl-12 col-lg-12 form-group">
                                            <label className="mb-5p">Other Vehicle Type<span style={{color:'red'}}>*</span>  </label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                onChange={(e)=> setFormData(prev =>({...prev, other_vehicle_type:e.target.value}))}
                                                value={formData.other_vehicle_type}
                                                name="truck_no"
                                                autoComplete='off'
                                                required
                                            />
                                        </div>}

                                           
                                        <div className="col-xl-12 col-lg-12 form-group">
                                                    <label className="mb-5p">Consignee Code</label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        onChange={(e) => {
                                                            const { value } = e.target;
                                                            setFormData(prev => ({...prev, consignee_code: value}));
                                                            // validateOtherConsignee(value);
                                                        }}
                                                        value={formData.consignee_code}
                                                        name="consignee_code"
                                                        autoComplete='off'
                                                    />
                                                    {/* {validOtherConsigneeName === false && <span style={{color:"red", fontSize:"12px", marginTop:"5px"}}>Enter Valid Consignee Name</span>} */}
                                                </div>

                                            {/* Consignee Name */}
                                        {formData.movement_type.value ==="Customer Delivery" && (<div className="col-xl-12 col-lg-12 form-group">
                                                    <label className="mb-5p">Consignee Name<span style={{color:'red'}}>*</span></label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        onChange={(e) => {
                                                            const { value } = e.target;
                                                            setFormData(prev => ({...prev, consignee_name1: value}));
                                                            // validateOtherConsignee(value);
                                                        }}
                                                        value={formData.consignee_name1}
                                                        name="other_consignee_name"
                                                        autoComplete='off'
                                                        required
                                                    />
                                                    {/* {validOtherConsigneeName === false && <span style={{color:"red", fontSize:"12px", marginTop:"5px"}}>Enter Valid Consignee Name</span>} */}
                                                </div>) }

                                                { formData.movement_type.value !=="Customer Delivery" && (  <div className="col-xl-12 col-lg-12 form-group">
                                            <label className="mb-5p">Consignee Name<span style={{color:'red'}}>*</span>  </label>
                                            <Select
                                                closeMenuOnSelect={true}
                                                value={formData.consignee_name}
                                                onChange={(e) => {                                                    
                                                    setFormData((prev) => ({
                                                        ...prev, 
                                                        consignee_name: {label: e.label, value: e.value}
                                                    }));
                                                    // Check if the selected option is "Other"
                                                    if (e.label !== "Others") {
                                                        fetchConsignerDetails(e.value, e.label);
                                                        setEnableConsigee(false)
                                                    } else {
                                                        setEnableConsigee(true)
                                                        setFormData(prev => ({...prev, destination_pincode: "", destination_city: ""}));
                                                    }

                                                    // Validate after updating the selection
                                                    validateOption("consigneeName");
                                                }}
                                                style={{ borderRadius: "0px" }}
                                                styles={{
                                                    control: (provided, state) => ({
                                                        ...provided,
                                                        fontSize: "0.8rem",
                                                        color: "#6e707e",
                                                        width:"100%"

                                                    }),
                                                    singleValue: (provided, state) => ({
                                                        ...provided,
                                                        fontSize: "0.9rem",
                                                    }),
                                                }}
                                                options={consignees}
                                            />
                                           
                                            {formData.consignee_name.value ==="Others" && <>
                                                <div className="col-xl-12 col-lg-12 form-group" style={{marginTop:"20px", padding:"0px"}}>
                                                    <label className="mb-5p">Other Consignee Name<span style={{color:'red'}}>*</span></label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        onChange={(e) => {
                                                            const { value } = e.target;
                                                            setFormData(prev => ({...prev, other_consignee_name: value}));
                                                            validateOtherConsignee(value);
                                                        }}
                                                        value={formData.other_consignee_name}
                                                        name="other_consignee_name"
                                                        autoComplete='off'
                                                        required
                                                    />
                                                    {validOtherConsigneeName === false && <span style={{color:"red", fontSize:"12px", marginTop:"5px"}}>Enter Valid Consignee Name</span>}
                                                </div>

                                                <div className="col-xl-12 col-lg-12 form-group" style={{ marginTop: "20px", padding: "0px" }}>
                                                    <label className="mb-5p">Other Destination City<span style={{ color: 'red' }}>*</span></label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        onChange={(e) => {
                                                            const {value} = e.target

                                                            setFormData(prev => ({ ...prev, other_destination_city: value }));
                                                            checkOtherConsigneeName(e.target.name, value); // Call validation here
                                                        }}
                                                        value={formData.other_destination_city}
                                                        name="other_destination_city"
                                                        autoComplete='off'
                                                        required
                                                    />
                                                    {validCity === false && <span style={{ color: "red", fontSize: "12px", marginTop: "5px" }}>Enter Valid City Name</span>}
                                                </div>
                                                <div className="col-xl-12 col-lg-12 form-group" style={{ marginTop: "20px", padding: "0px" }}>
                                                    <label className="mb-5p">Other Destination Pincode<span style={{ color: 'red' }}>*</span></label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        onChange={(e) => {
                                                            const {value} = e.target
                                                            setFormData(prev => ({ ...prev, other_destination_pincode: value }));
                                                            checkOtherConsigneeName(e.target.name, value); // Call validation here
                                                        }}
                                                        value={formData.other_destination_pincode}
                                                        name="other_destination_pincode"
                                                        autoComplete='off'
                                                        required
                                                    />
                                                    {validPincode === false && <span style={{ color: "red", fontSize: "12px", marginTop: "5px" }}>Enter Valid Pincode</span>}
                                                </div>

                                            </>
                                            }

                                       
                                            
                                        </div>
                                      )}

                                       
                                        {/* courier partner - transporter */}
                                                                                
                                        {/* vehicle capacity */}
                                        {!enableVehicleType && <div className="form-group col-xl-12 col-lg-12">
                                            <label className="mb-5p">
                                                Vehicle Capacity<span style={{color: 'red'}}>*</span>
                                            </label>
                                            <input
                                                    type="text"
                                                    className="form-control"
                                                    // onChange={(e)=> setFormData(prev => ({...prev, destination_pincode:e.target.value }))}
                                                    value={formData.vehicle_capacity}
                                                    name="vehicle_capacity"
                                                    autoComplete='off'
                                                    // onFocus={checkConsignee}
                                                    disabled={true}
                                                    
                                                />
                                            {/* <Select
                                                closeMenuOnSelect={true}
                                                value={formData.vehicle_capacity}
                                                className="custom-field-width"
                                                onChange={(e) => {
                                                    setFormData((prev) => ({
                                                        ...prev,
                                                        vehicle_capacity: { label: e.label, value: e.value }
                                                    }));

                                                    // Enable Other Vehicle Capacity field when "Other" is selected
                                                    // if (e.value === "Others") {
                                                    //     setEnableVehicleCapacity(true);
                                                    // } else {
                                                    //     setFormData((prev) => ({ ...prev, other_vehicle_capacity: "" }));
                                                    //     setEnableVehicleCapacity(false);
                                                    // }
                                                }}
                                                style={{ borderRadius: "0px" }}
                                                styles={{
                                                    control: (provided, state) => ({
                                                        ...provided,
                                                        fontSize: "0.8rem",
                                                        color: "#6e707e",
                                                    }),
                                                    singleValue: (provided, state) => ({
                                                        ...provided,
                                                        fontSize: "0.9rem",
                                                    }),
                                                }}
                                                // options={vehicleCapacityList}
                                            /> */}
                                        </div>}
                                        {enableVehicleType && <div className="col-xl-12 col-lg-12 form-group">
                                            <label className="mb-5p">
                                                Other Vehicle Capacity<span style={{color:'red'}}>*</span>
                                            </label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                onChange={handleVehicleCapacityChange} 
                                                value={formData.other_vehicle_capacity}
                                                name="other_vehicle_capacity"
                                                autoComplete='off'
                                                required
                                            />
                                            {validVehicleCapacity === false && (
                                                <span style={{color:"red", fontSize:"12px", marginTop:"5px", marginLeft:"16px"}}>
                                                    Enter Valid Vehicle Capacity
                                                </span>
                                            )}
                                        </div>}
                                            {/* No Of Boxes */}
                                            <div className="col-xl-12 col-lg-12 form-group">
                                                <label className="mb-5p">Number of Boxes</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    onChange={(e) =>
                                                        setFormData((prev) => ({ ...prev, number_of_boxes: e.target.value }))
                                                    }
                                                    onInput={(e) => {
                                                        // Remove non-numeric characters
                                                        e.target.value = e.target.value.replace(/[^0-9]/g, '');
                                                    }}
                                                    value={formData.number_of_boxes}
                                                    name="number_of_boxes"
                                                    autoComplete="off"
                                                />
                                            </div>

                                        {formData.consignee_name.value !=="Others" && 
                                        <>                                         
                                            <div className="col-xl-12 col-lg-12 form-group">
                                                <label className="mb-5p">Destination City<span style={{color:'red'}}>*</span>  </label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    onChange={(e)=> setFormData(prev => ({...prev, destination_city:e.target.value }))}
                                                    value={formData.destination_city}
                                                    name="destination_city"
                                                    autoComplete='off'
                                                    // onFocus={checkConsignee}
                                                    disabled={!enableEdit}
                                                    required={enableEdit}
                                                />
                                            </div>                                    
                                            <div className="col-xl-12 col-lg-12 form-group">
                                            <label className="mb-5p">Destination Pincode<span style={{color:'red'}}>*</span>  </label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    onChange={(e)=> setFormData(prev => ({...prev, destination_pincode:e.target.value }))}
                                                    value={formData.destination_pincode}
                                                    name="destination_pincode"
                                                    autoComplete='off'
                                                    // onFocus={checkConsignee}
                                                    disabled={!enableEdit}
                                                    required={enableEdit}
                                                />
                                                </div>

                                        </>
                                    }
                                        {/* Eway bill */}
                                        <div className="form-group col-xl-12 col-lg-12">
                                            <label className="mb-5p">E-Way Bill Expiry Date</label>
                                            <div id="datepicker1">
                                                <DatePicker
                                                selected={formData.eway_bill_expiry_date}
                                                onChange={handleEwayDate}
                                                name="eway_bill_expiry_date"
                                                className="datepicker-custom-ptl4 form-control1"
                                                showTimeSelect
                                                timeFormat="HH:mm:ss"
                                                timeIntervals={15} // Adjust this if you want different time intervals
                                                timeCaption="Time"
                                                dateFormat="dd-MM-yyyy HH:mm:ss" // Adjusted format to match the original format
                                                minDate={new Date()} // Prevents past date selection
                                                id="eway_bill_expiry_date"
                                                autoComplete="off"
                                                onKeyDown={(e) => e.preventDefault()}
                                                />
                                            </div>
                                        </div> 
                                        <div className="col-xl-12 col-lg-12 form-group">
                                            <label className="mb-5p">Total Weight</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                onChange={(e) => {
                                                    const value = e.target.value;
                                                    // Allow only numeric values (including empty string for clearing the input)
                                                    if (/^\d*\.?\d*$/.test(value)) {
                                                        setFormData((prev) => ({ ...prev, total_weight: value }));
                                                    }
                                                }}
                                                value={formData.total_weight}
                                                name="total_weight"
                                                autoComplete="off"
                                            />
                                            {!/^\d*\.?\d+$/.test(formData.total_weight) && formData.total_weight !== '' && (
                                                <span style={{ color: "red", fontSize: "12px", marginTop: "5px" }}>
                                                    Total Weight must be a numeric value.
                                                </span>
                                            )}
                                        </div>

                                        <div className="col-xl-12 col-lg-12 form-group">
                                            <label className="mb-5p">Total CBM</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                onChange={(e) => {
                                                    const value = e.target.value;
                                                    // Allow only numeric values (including empty string for clearing the input)
                                                    if (/^\d*\.?\d*$/.test(value)) {
                                                        setFormData((prev) => ({ ...prev, total_cbm: value }));
                                                    }
                                                }}
                                                value={formData.total_cbm}
                                                name="total_cbm"
                                                autoComplete="off"
                                            />
                                            {!/^\d*\.?\d+$/.test(formData.total_cbm) && formData.total_cbm !== '' && (
                                                <span style={{ color: "red", fontSize: "12px", marginTop: "5px" }}>
                                                    Total CBM must be a numeric value.
                                                </span>
                                            )}
                                        </div>

                                        {/* No Of Boxes */}
                                        <div className="col-xl-12 col-lg-12 form-group">
                                            <label className="mb-5p">Fuel Type<span style={{color:'red'}}>*</span></label>
                                            <Select
                                                closeMenuOnSelect={true}
                                                value={formData.fuel_type}
                                                onChange={(e)=> setFormData((prev)=>({
                                                    ...prev, 
                                                    fuel_type:{label:e.label, value: e.value}
                                                }))}
                                                style={{ borderRadius: "0px" }}
                                                styles={{
                                                    control: (provided, state) => ({
                                                    ...provided,
                                                    fontSize: "0.8rem",
                                                    color: "#6e707e",
                                                    width:"100%"
                                                    }),
                                                    singleValue: (provided, state) => ({
                                                    ...provided,
                                                    fontSize: "0.9rem",
                                                    }),
                                                }}
                                                options={validFuelTypeList}
                                                required
                                            />
                                        </div>
                                     
                                      
                                    
                                     
                                   
                                    {/* <div style={{padding:"5px"}}>
                                    {manualTripUploadDetails.map((point, index) => (
                                        <div key={point.id} style={{ padding: '20px', border: '1px solid #ccc', marginBottom: '20px' }}> */}
                                            {/* <div className="slide-body">
                                                <div className="row p-20p"> */}
                                                    {/* <div className="col-xl-12 col-lg-12 d-flex justify-content-between align-items-center">
                                                        <h3>Drop Point {index + 1}</h3>
                                                        <button
                                                            type="button"
                                                            className="btn btn-danger"
                                                            onClick={() => handleRemoveDropPoint(point.id)}
                                                        >
                                                            Delete
                                                        </button>
                                                    </div> */}

                                                    {/* LR No Field */}
                                                    {/* <div className="form-group col-xl-12 col-lg-12">
                                                        <label className="mb-5p"> */}
                                                            {/* LR No */}
                                                            {/* <span style={{ color: 'red' }}>*</span> */}
                                                        {/* </label> */}
                                                        {/* <input
                                                            type="text"
                                                            name="lr_no"
                                                            value={formData.lr_no}
                                                            className="form-control" */}
                                                            {/* // onChange={(e) => */}
                                                            {/* //     handleInputChange(point.id, 'lr_no', e.target.value)
                                                            // }
                                                            // required
                                                        // /> */}
                                                        {/* {validationErrors[point.id]?.lr_no && (
                                                            <span className="text-danger">{validationErrors[point.id].lr_no}</span>
                                                        )} */}
                                                    {/* </div> */}

                                                    {/* Invoice No Field */}
                                                    {/* <div className="form-group col-xl-12 col-lg-12">
                                                        <label className="mb-5p">
                                                            Invoice No<span style={{ color: 'red' }}>*</span>
                                                        </label>
                                                        <input
                                                            type="text"
                                                            name="invoice_no"
                                                            value={point.invoice_no}
                                                            className="form-control"
                                                            onChange={(e) =>
                                                                handleInputChange(index, 'invoice_no', e.target.value.toUpperCase())
                                                            }
                                                            autoComplete='off'
                                                            required
                                                        />
                                                        {validationErrors[index]?.invoice_no && (
                                                            <span style={{color:"red", fontSize:"12px",marginTop:"5px"}}>{validationErrors[index].invoice_no}</span>
                                                        )}
                                                    </div> */}
                                                    {/* Consignee Name Field */}
                                                    {/* <div className="form-group col-xl-12 col-lg-12">
                                                        <label className="mb-5p">
                                                            Consignee Name<span style={{ color: 'red' }}>*</span>
                                                        </label>
                                                        <Select
                                                            closeMenuOnSelect={true}
                                                            value={dropPointConsignee.find(option => option.value === point.consignee_name) || null}
                                                            options={dropPointConsignee.filter((option, optIndex) => {
                                                                // Filter out consignees that were selected in any previous blocks
                                                                const selectedInPreviousBlocks = manualTripUploadDetails
                                                                    .slice(0, index)
                                                                    .some(prevPoint => prevPoint.consignee_name === option.value);

                                                                return !selectedInPreviousBlocks;
                                                            })}
                                                            onChange={(selectedOption) => {
                                                                handleConsigneeChange(point.id, selectedOption.value);
                                                                if (selectedOption.value && selectedOption.value !== "Others") {
                                                                    fetchDestinationDetails(selectedOption.value, point.id);
                                                                }
                                                            }}
                                                            required
                                                        />
                                                        {validationErrors[point.id]?.consignee_name && (
                                                            <span style={{color:"red", fontSize:"12px",marginTop:"5px"}}>{validationErrors[point.id].consignee_name}</span>
                                                        )}

                                                        {showCustomConsigneeInput[point.id] && (
                                                        <>
                                                            <div className="form-group col-xl-12 col-lg-12" style={{ marginTop: "20px", padding: "0px" }}>
                                                                <label className="mb-5p">Other Consignee Name<span style={{ color: 'red' }}>*</span></label>
                                                                <input
                                                                    type="text"
                                                                    name="other_consignee_name"
                                                                    className="form-control"
                                                                    onChange={(e) => handleInputChange(index, 'other_consignee_name', e.target.value)}
                                                                    value={point.other_consignee_name || ""}
                                                                    autoComplete='off'
                                                                    required
                                                                />
                                                            </div>
                                                            <div className="form-group col-xl-12 col-lg-12" style={{ marginTop: "20px", padding: "0px" }}>
                                                                <label className="mb-5p">Other Destination City<span style={{ color: 'red' }}>*</span></label>
                                                                <input
                                                                    type="text"
                                                                    name="other_consignee_city"
                                                                    className="form-control"
                                                                    onChange={(e) => {
                                                                        const {value} = e.target
                                                                        handleInputChange(index, 'other_consignee_city', value)
                                                                        checkOtherConsigneeName("other_consignee_city1", value)
                                                                    }}
                                                                    value={point.other_consignee_city || ""}
                                                                    autoComplete='off'
                                                                    required
                                                                />
                                                            {validCity1 === false && <span style={{ color: "red", fontSize: "12px", marginTop: "5px" }}>Enter Valid City Name</span>}

                                                            </div>
                                                            <div className="form-group col-xl-12 col-lg-12" style={{ marginTop: "20px", padding: "0px" }}>
                                                                <label className="mb-5p">Other Destination Pincode<span style={{ color: 'red' }}>*</span></label>
                                                                <input
                                                                    type="text"
                                                                    name="other_consignee_pincode"
                                                                    className="form-control"
                                                                    onChange={(e) => {
                                                                        const {value} = e.target
                                                                        handleInputChange(index, 'other_consignee_pincode', value)
                                                                        checkOtherConsigneeName("other_consignee_pincode1", value)
                                                                    }}
                                                                    value={point.other_consignee_pincode || ""}
                                                                    autoComplete='off'
                                                                    required
                                                                />
                                                    {validPincode1 === false && <span style={{ color: "red", fontSize: "12px", marginTop: "5px" }}>Enter Valid Pincode</span>}
                                                    </div>
                                                        </>
                                                        )}
                                                    </div> */}
                                                    {/* {!showCustomConsigneeInput[point.id] && (
                                                        <>                                                         */}
                                                            {/* Destination City Field */}
                                                            {/* <div className="form-group col-xl-12 col-lg-12">
                                                                <label className="mb-5p">
                                                                    Destination City<span style={{ color: 'red' }}>*</span>
                                                                </label>
                                                                <input
                                                                    type="text"
                                                                    name="destination_city"
                                                                    value={point.destination_city}
                                                                    className="form-control"
                                                                    onChange={(e) =>
                                                                        handleInputChange(index, 'destination_city', e.target.value)
                                                                    }
                                                                    autoComplete='off'
                                                                    required
                                                                />
                                                                {validationErrors[point.id]?.destination_city && (
                                                                    <span style={{color:"red", fontSize:"12px",marginTop:"5px"}}>{validationErrors[point.id].destination_city}</span>
                                                                )}
                                                            </div> */}
                                                            {/* Destination Pincode Field */}
                                                            {/* <div className="form-group col-xl-12 col-lg-12">
                                                                <label className="mb-5p">
                                                                    Destination Pincode<span style={{ color: 'red' }}>*</span>
                                                                </label>
                                                                <input
                                                                    type="text"
                                                                    name="destination_pincode"
                                                                    value={point.destination_pincode}
                                                                    className="form-control"
                                                                    onChange={(e) =>
                                                                        handleInputChange(index, 'destination_pincode', e.target.value)
                                                                    }
                                                                    autoComplete='off'
                                                                    required
                                                                />
                                                                {validationErrors[point.id]?.destination_pincode && (
                                                                    <span style={{color:"red", fontSize:"12px",marginTop:"5px"}}>{validationErrors[point.id].destination_pincode}</span>
                                                                )}
                                                            </div> */}
                                                        {/* </>
                                                    )} */}
                                                {/* </div>
                                            </div> */}
                                        {/* </div>
                                    ))}


                                    </div> */}

                            {/* Submit Button */}
                            <div className="form-group col-sm-12 mb-20p text-center">
                                        {/* <button
                                            type="button"
                                            className={`btn customAddBtn${isFormValid() && isManualTripUploadDetailsValid() && !invoiceValid? 'btn-primary' : 'btn-disabled'}`}
                                            onClick={handleButtonClick}
                                            style={{ padding: '9px 10px', fontSize: '12px', cursor: 'pointer',borderRadius:"none" ,marginRight:"20px" }}
                                            disabled={!isFormValid() || !isManualTripUploadDetailsValid() && invoiceValid}
                                            >
                                            Add Drop Point
                                        </button> */}
                                        <button
                                            type="submit"
                                            className={`btn ${((isFormValid() && isManualTripUploadDetailsValid() && !invoiceValid ) || !isValid1)? 'btn-success' : 'btn-disabled'}`}
                                            disabled={(!isFormValid() && !isManualTripUploadDetailsValid() && invoiceValid) || isValid1}
                                            >
                                            Submit
                                        </button>
                                    </div>

                        </div>
                    </div>
                </form>
            </div>
            {/* <div className={"overlay-part " + (overly)} style={{ zIndex: "10" }}
                    // onClick={onClickHideAll}
                ></div>
                <div className={"dataLoadpage " + (loadshow)}></div>
                <div className={"dataLoadpageimg " + (loadshow)} style={{ top: "21em" }}>
                    <div className="loader-box"><div className="loader-box"><div className="rotate dashed colored"></div></div></div>
                </div> */}
        </div>
        </>
    );
};

export default AddConsignmentSlider;
const formatDateForSubmission = (date) => {
    // Check if the input is a valid Date object
    if (!(date instanceof Date)) {
        // Try to convert it to a Date object if possible
        date = new Date(date);
    }

    // If the date is still invalid, handle the error
    if (isNaN(date.getTime())) {
        throw new Error("Invalid date format");
    }

const pad = (num) => num.toString().padStart(2, '0');
return `${pad(date.getDate())}-${pad(date.getMonth() + 1)}-${date.getFullYear()}`;
};
const formatDateForSubmission1 = (date) => {
// Check if the input is a valid Date object
if (!(date instanceof Date)) {
    // Try to convert it to a Date object if possible
    date = new Date(date);
}

// If the date is still invalid, handle the error
if (isNaN(date.getTime())) {
    throw new Error("Invalid date format");
}

const pad = (num) => num.toString().padStart(2, '0');
return `${pad(date.getDate())}-${pad(date.getMonth() + 1)}-${date.getFullYear()} ${pad(date.getHours())}:${pad(date.getMinutes())}`;
};